(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customDesign"]) return;
  try {
    
  jQuery('.openContact').click(()=>{
    jQuery('.contactWrapper').css('display','flex');
  })  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product2"]) return;
  try {
    
jQuery(document).ready(function(){

  //  if(window.innerWidth < 767){
  //   jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
  // }

  //   const container = document.querySelector('.product__media-list');
  // const items = document.querySelectorAll('.product__media-list li');
  
  // container.addEventListener('scroll', () => {
  //   // Get the container's center position
  //   const containerCenter = container.scrollLeft + container.offsetWidth / 2;
  
  //   // Loop through the items and find the one closest to the center
  //   let closestItem = null;
  //   let closestDistance = Infinity;
  
  //   items.forEach(item => {
  //     const itemCenter = item.offsetLeft + item.offsetWidth / 2;
  //     const distance = Math.abs(containerCenter - itemCenter);
  
  //     if (distance < closestDistance) {
  //       closestDistance = distance;
  //       closestItem = item;
  //     }
  //   });
  
  //   if (closestItem) {
  //     if(window.innerWidth < 767){
  //       jQuery('.product__media-list').css('height',`${closestItem.offsetHeight + 54}`);
  //     }
  //   }
  // });
  

  function scrollHandler(e) {
      var atSnappingPoint = e.target.scrollLeft % e.target.offsetWidth === 0;
      var timeOut         = atSnappingPoint ? 0 : 150; //see notes
  
      clearTimeout(e.target.scrollTimeout); //clear previous timeout
  
      e.target.scrollTimeout = setTimeout(function() {
        scrollHandler2();
          console.log('Scrolling stopped!', jQuery('.product__media-item.grid__item.slider__slide.is-active').height());
      }, timeOut);
  }
  
  // jQuery('.product__media-list')[0].addEventListener('scroll', scrollHandler);

  jQuery('.slider-mobile-gutter').eq(0).prepend(`<span class="sliderNext"> ❯ </span>`);
  jQuery('.slider-mobile-gutter').eq(0).prepend(`<span class="sliderPrev"> ❮ </span>`);
  // if(window.innerWidth < 767){
  //   jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
  // }
  document.addEventListener('click',function (e) {
    if (e.target.className == 'sliderNext') {
        changeSlide('next');
      // if(window.innerWidth < 767){
      //   jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
      // }
    } else if (e.target.className == 'sliderPrev') {
        changeSlide('prev');
      // if(window.innerWidth < 767){
      //   jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
      // }
    }
  })

  

  document.addEventListener('click', function (e) {
    if(e.target.className.includes('openCareGuide')){
        document.querySelector('.careGuide').style.display = 'flex';
    } else if(e.target.className.includes('close')){
        document.querySelector('.careGuide').style.display = 'none';
    }
  })
  
})  

  if (document.querySelector('.product__info-container select[name="Unisex Size"]') != null ){
    document.querySelector('.product__info-container select[name="Unisex Size"]').addEventListener('change',function () {
        let selectedVal = document.querySelector('.product__info-container select[name="Unisex Size"] option:checked').value;
        let selectedId = document.querySelector(`input[name="Unisex Size"][value="${selectedVal}"]`).getAttribute('id');
        document.querySelector(`label[for="${selectedId}"]`).click();
        if(selectedVal.length != 0){
          document.querySelector('.product__info-container select[name="Unisex Size"]').classList.add('active')
        }
    })
  }
  
  if (document.querySelector('.product__info-container select[name="Size"]') != null ){
    document.querySelector('.product__info-container select[name="Size"]').addEventListener('change',function () {
        let selectedVal = document.querySelector('.product__info-container select[name="Size"] option:checked').value;
        let selectedId = document.querySelector(`input[name="Size"][value="${selectedVal}"]`).getAttribute('id');
        document.querySelector(`label[for="${selectedId}"]`).click();
        if(selectedVal.length != 0){
          document.querySelector('.product__info-container select[name="Size"]').classList.add('active')
        }
    })

  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product3"]) return;
  try {
    
jQuery(document).ready(function(){

   if(window.innerWidth < 767){
    jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
  }

    const container = document.querySelector('.product__media-list');
  const items = document.querySelectorAll('.product__media-list li');
  
  container.addEventListener('scroll', () => {
    // Get the container's center position
    const containerCenter = container.scrollLeft + container.offsetWidth / 2;
  
    // Loop through the items and find the one closest to the center
    let closestItem = null;
    let closestDistance = Infinity;
  
    items.forEach(item => {
      const itemCenter = item.offsetLeft + item.offsetWidth / 2;
      const distance = Math.abs(containerCenter - itemCenter);
  
      if (distance < closestDistance) {
        closestDistance = distance;
        closestItem = item;
      }
    });
  
    if (closestItem) {
      if(window.innerWidth < 767){
        jQuery('.product__media-list').css('height',`${closestItem.offsetHeight + 54}`);
      }
    }
  });
  

  function scrollHandler(e) {
      var atSnappingPoint = e.target.scrollLeft % e.target.offsetWidth === 0;
      var timeOut         = atSnappingPoint ? 0 : 150; //see notes
  
      clearTimeout(e.target.scrollTimeout); //clear previous timeout
  
      e.target.scrollTimeout = setTimeout(function() {
        scrollHandler2();
          console.log('Scrolling stopped!', jQuery('.product__media-item.grid__item.slider__slide.is-active').height());
      }, timeOut);
  }
  
  // jQuery('.product__media-list')[0].addEventListener('scroll', scrollHandler);

  jQuery('.slider-mobile-gutter').eq(0).prepend(`<span class="sliderNext"> ❯ </span>`);
  jQuery('.slider-mobile-gutter').eq(0).prepend(`<span class="sliderPrev"> ❮ </span>`);
  if(window.innerWidth < 767){
    jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
  }
  document.addEventListener('click',function (e) {
    if (e.target.className == 'sliderNext') {
        changeSlide('next');
      // if(window.innerWidth < 767){
      //   jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
      // }
    } else if (e.target.className == 'sliderPrev') {
        changeSlide('prev');
      // if(window.innerWidth < 767){
      //   jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
      // }
    }
  })

  

  document.addEventListener('click', function (e) {
    if(e.target.className.includes('openCareGuide')){
        document.querySelector('.careGuide').style.display = 'flex';
    } else if(e.target.className.includes('close')){
        document.querySelector('.careGuide').style.display = 'none';
    }
  })
  
})  

  if (document.querySelector('.product__info-container select[name="Unisex Size"]') != null ){
    document.querySelector('.product__info-container select[name="Unisex Size"]').addEventListener('change',function () {
        let selectedVal = document.querySelector('.product__info-container select[name="Unisex Size"] option:checked').value;
        let selectedId = document.querySelector(`input[name="Unisex Size"][value="${selectedVal}"]`).getAttribute('id');
        document.querySelector(`label[for="${selectedId}"]`).click();
        if(selectedVal.length != 0){
          document.querySelector('.product__info-container select[name="Unisex Size"]').classList.add('active')
        }
    })
  }
  
  if (document.querySelector('.product__info-container select[name="Size"]') != null ){
    document.querySelector('.product__info-container select[name="Size"]').addEventListener('change',function () {
        let selectedVal = document.querySelector('.product__info-container select[name="Size"] option:checked').value;
        let selectedId = document.querySelector(`input[name="Size"][value="${selectedVal}"]`).getAttribute('id');
        document.querySelector(`label[for="${selectedId}"]`).click();
        if(selectedVal.length != 0){
          document.querySelector('.product__info-container select[name="Size"]').classList.add('active')
        }
    })

  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product4"]) return;
  try {
    
jQuery(document).ready(function(){

   if(window.innerWidth < 767){
    jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
  }

    const container = document.querySelector('.product__media-list');
  const items = document.querySelectorAll('.product__media-list li');
  
  container.addEventListener('scroll', () => {
    // Get the container's center position
    const containerCenter = container.scrollLeft + container.offsetWidth / 2;
  
    // Loop through the items and find the one closest to the center
    let closestItem = null;
    let closestDistance = Infinity;
  
    items.forEach(item => {
      const itemCenter = item.offsetLeft + item.offsetWidth / 2;
      const distance = Math.abs(containerCenter - itemCenter);
  
      if (distance < closestDistance) {
        closestDistance = distance;
        closestItem = item;
      }
    });
  
    if (closestItem) {
      if(window.innerWidth < 767){
        jQuery('.product__media-list').css('height',`${closestItem.offsetHeight + 54}`);
      }
    }
  });
  

  function scrollHandler(e) {
      var atSnappingPoint = e.target.scrollLeft % e.target.offsetWidth === 0;
      var timeOut         = atSnappingPoint ? 0 : 150; //see notes
  
      clearTimeout(e.target.scrollTimeout); //clear previous timeout
  
      e.target.scrollTimeout = setTimeout(function() {
        scrollHandler2();
          console.log('Scrolling stopped!', jQuery('.product__media-item.grid__item.slider__slide.is-active').height());
      }, timeOut);
  }
  
  // jQuery('.product__media-list')[0].addEventListener('scroll', scrollHandler);

  jQuery('.slider-mobile-gutter').eq(0).prepend(`<span class="sliderNext"> ❯ </span>`);
  jQuery('.slider-mobile-gutter').eq(0).prepend(`<span class="sliderPrev"> ❮ </span>`);
  if(window.innerWidth < 767){
    jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
  }
  document.addEventListener('click',function (e) {
    if (e.target.className == 'sliderNext') {
        changeSlide('next');
      // if(window.innerWidth < 767){
      //   jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
      // }
    } else if (e.target.className == 'sliderPrev') {
        changeSlide('prev');
      // if(window.innerWidth < 767){
      //   jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
      // }
    }
  })

  

  document.addEventListener('click', function (e) {
    if(e.target.className.includes('openCareGuide')){
        document.querySelector('.careGuide').style.display = 'flex';
    } else if(e.target.className.includes('close')){
        document.querySelector('.careGuide').style.display = 'none';
    }
  })
  
})  

  if (document.querySelector('.product__info-container select[name="Unisex Size"]') != null ){
    document.querySelector('.product__info-container select[name="Unisex Size"]').addEventListener('change',function () {
        let selectedVal = document.querySelector('.product__info-container select[name="Unisex Size"] option:checked').value;
        let selectedId = document.querySelector(`input[name="Unisex Size"][value="${selectedVal}"]`).getAttribute('id');
        document.querySelector(`label[for="${selectedId}"]`).click();
        if(selectedVal.length != 0){
          document.querySelector('.product__info-container select[name="Unisex Size"]').classList.add('active')
        }
    })
  }
  
  if (document.querySelector('.product__info-container select[name="Size"]') != null ){
    document.querySelector('.product__info-container select[name="Size"]').addEventListener('change',function () {
        let selectedVal = document.querySelector('.product__info-container select[name="Size"] option:checked').value;
        let selectedId = document.querySelector(`input[name="Size"][value="${selectedVal}"]`).getAttribute('id');
        document.querySelector(`label[for="${selectedId}"]`).click();
        if(selectedVal.length != 0){
          document.querySelector('.product__info-container select[name="Size"]').classList.add('active')
        }
    })

  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product5"]) return;
  try {
    
jQuery(document).ready(function(){

   if(window.innerWidth < 767){
    jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
  }

    const container = document.querySelector('.product__media-list');
  const items = document.querySelectorAll('.product__media-list li');
  
  container.addEventListener('scroll', () => {
    // Get the container's center position
    const containerCenter = container.scrollLeft + container.offsetWidth / 2;
  
    // Loop through the items and find the one closest to the center
    let closestItem = null;
    let closestDistance = Infinity;
  
    items.forEach(item => {
      const itemCenter = item.offsetLeft + item.offsetWidth / 2;
      const distance = Math.abs(containerCenter - itemCenter);
  
      if (distance < closestDistance) {
        closestDistance = distance;
        closestItem = item;
      }
    });
  
    if (closestItem) {
      if(window.innerWidth < 767){
        jQuery('.product__media-list').css('height',`${closestItem.offsetHeight + 54}`);
      }
    }
  });
  

  function scrollHandler(e) {
      var atSnappingPoint = e.target.scrollLeft % e.target.offsetWidth === 0;
      var timeOut         = atSnappingPoint ? 0 : 150; //see notes
  
      clearTimeout(e.target.scrollTimeout); //clear previous timeout
  
      e.target.scrollTimeout = setTimeout(function() {
        scrollHandler2();
          console.log('Scrolling stopped!', jQuery('.product__media-item.grid__item.slider__slide.is-active').height());
      }, timeOut);
  }
  
  // jQuery('.product__media-list')[0].addEventListener('scroll', scrollHandler);

  jQuery('.slider-mobile-gutter').eq(0).prepend(`<span class="sliderNext"> ❯ </span>`);
  jQuery('.slider-mobile-gutter').eq(0).prepend(`<span class="sliderPrev"> ❮ </span>`);
  if(window.innerWidth < 767){
    jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
  }
  document.addEventListener('click',function (e) {
    if (e.target.className == 'sliderNext') {
        changeSlide('next');
      // if(window.innerWidth < 767){
      //   jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
      // }
    } else if (e.target.className == 'sliderPrev') {
        changeSlide('prev');
      // if(window.innerWidth < 767){
      //   jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
      // }
    }
  })

  

  document.addEventListener('click', function (e) {
    if(e.target.className.includes('openCareGuide')){
        document.querySelector('.careGuide').style.display = 'flex';
    } else if(e.target.className.includes('close')){
        document.querySelector('.careGuide').style.display = 'none';
    }
  })
  
})  

  if (document.querySelector('.product__info-container select[name="Unisex Size"]') != null ){
    document.querySelector('.product__info-container select[name="Unisex Size"]').addEventListener('change',function () {
        let selectedVal = document.querySelector('.product__info-container select[name="Unisex Size"] option:checked').value;
        let selectedId = document.querySelector(`input[name="Unisex Size"][value="${selectedVal}"]`).getAttribute('id');
        document.querySelector(`label[for="${selectedId}"]`).click();
        if(selectedVal.length != 0){
          document.querySelector('.product__info-container select[name="Unisex Size"]').classList.add('active')
        }
    })
  }
  
  if (document.querySelector('.product__info-container select[name="Size"]') != null ){
    document.querySelector('.product__info-container select[name="Size"]').addEventListener('change',function () {
        let selectedVal = document.querySelector('.product__info-container select[name="Size"] option:checked').value;
        let selectedId = document.querySelector(`input[name="Size"][value="${selectedVal}"]`).getAttribute('id');
        document.querySelector(`label[for="${selectedId}"]`).click();
        if(selectedVal.length != 0){
          document.querySelector('.product__info-container select[name="Size"]').classList.add('active')
        }
    })

  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product6"]) return;
  try {
    
jQuery(document).ready(function(){

   if(window.innerWidth < 767){
    jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
  }

    const container = document.querySelector('.product__media-list');
  const items = document.querySelectorAll('.product__media-list li');
  
  container.addEventListener('scroll', () => {
    // Get the container's center position
    const containerCenter = container.scrollLeft + container.offsetWidth / 2;
  
    // Loop through the items and find the one closest to the center
    let closestItem = null;
    let closestDistance = Infinity;
  
    items.forEach(item => {
      const itemCenter = item.offsetLeft + item.offsetWidth / 2;
      const distance = Math.abs(containerCenter - itemCenter);
  
      if (distance < closestDistance) {
        closestDistance = distance;
        closestItem = item;
      }
    });
  
    if (closestItem) {
      if(window.innerWidth < 767){
        jQuery('.product__media-list').css('height',`${closestItem.offsetHeight + 54}`);
      }
    }
  });
  

  function scrollHandler(e) {
      var atSnappingPoint = e.target.scrollLeft % e.target.offsetWidth === 0;
      var timeOut         = atSnappingPoint ? 0 : 150; //see notes
  
      clearTimeout(e.target.scrollTimeout); //clear previous timeout
  
      e.target.scrollTimeout = setTimeout(function() {
        scrollHandler2();
          console.log('Scrolling stopped!', jQuery('.product__media-item.grid__item.slider__slide.is-active').height());
      }, timeOut);
  }
  
  // jQuery('.product__media-list')[0].addEventListener('scroll', scrollHandler);

  jQuery('.slider-mobile-gutter').eq(0).prepend(`<span class="sliderNext"> ❯ </span>`);
  jQuery('.slider-mobile-gutter').eq(0).prepend(`<span class="sliderPrev"> ❮ </span>`);
  if(window.innerWidth < 767){
    jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
  }
  document.addEventListener('click',function (e) {
    if (e.target.className == 'sliderNext') {
        changeSlide('next');
      // if(window.innerWidth < 767){
      //   jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
      // }
    } else if (e.target.className == 'sliderPrev') {
        changeSlide('prev');
      // if(window.innerWidth < 767){
      //   jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
      // }
    }
  })

  

  document.addEventListener('click', function (e) {
    if(e.target.className.includes('openCareGuide')){
        document.querySelector('.careGuide').style.display = 'flex';
    } else if(e.target.className.includes('close')){
        document.querySelector('.careGuide').style.display = 'none';
    }
  })
  
})  

  if (document.querySelector('.product__info-container select[name="Unisex Size"]') != null ){
    document.querySelector('.product__info-container select[name="Unisex Size"]').addEventListener('change',function () {
        let selectedVal = document.querySelector('.product__info-container select[name="Unisex Size"] option:checked').value;
        let selectedId = document.querySelector(`input[name="Unisex Size"][value="${selectedVal}"]`).getAttribute('id');
        document.querySelector(`label[for="${selectedId}"]`).click();
        if(selectedVal.length != 0){
          document.querySelector('.product__info-container select[name="Unisex Size"]').classList.add('active')
        }
    })
  }
  
  if (document.querySelector('.product__info-container select[name="Size"]') != null ){
    document.querySelector('.product__info-container select[name="Size"]').addEventListener('change',function () {
        let selectedVal = document.querySelector('.product__info-container select[name="Size"] option:checked').value;
        let selectedId = document.querySelector(`input[name="Size"][value="${selectedVal}"]`).getAttribute('id');
        document.querySelector(`label[for="${selectedId}"]`).click();
        if(selectedVal.length != 0){
          document.querySelector('.product__info-container select[name="Size"]').classList.add('active')
        }
    })

  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product7"]) return;
  try {
    
jQuery(document).ready(function(){

   if(window.innerWidth < 767){
    jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
  }

    const container = document.querySelector('.product__media-list');
  const items = document.querySelectorAll('.product__media-list li');
  
  container.addEventListener('scroll', () => {
    // Get the container's center position
    const containerCenter = container.scrollLeft + container.offsetWidth / 2;
  
    // Loop through the items and find the one closest to the center
    let closestItem = null;
    let closestDistance = Infinity;
  
    items.forEach(item => {
      const itemCenter = item.offsetLeft + item.offsetWidth / 2;
      const distance = Math.abs(containerCenter - itemCenter);
  
      if (distance < closestDistance) {
        closestDistance = distance;
        closestItem = item;
      }
    });
  
    if (closestItem) {
      if(window.innerWidth < 767){
        jQuery('.product__media-list').css('height',`${closestItem.offsetHeight + 54}`);
      }
    }
  });
  

  function scrollHandler(e) {
      var atSnappingPoint = e.target.scrollLeft % e.target.offsetWidth === 0;
      var timeOut         = atSnappingPoint ? 0 : 150; //see notes
  
      clearTimeout(e.target.scrollTimeout); //clear previous timeout
  
      e.target.scrollTimeout = setTimeout(function() {
        scrollHandler2();
          console.log('Scrolling stopped!', jQuery('.product__media-item.grid__item.slider__slide.is-active').height());
      }, timeOut);
  }
  
  // jQuery('.product__media-list')[0].addEventListener('scroll', scrollHandler);

  jQuery('.slider-mobile-gutter').eq(0).prepend(`<span class="sliderNext"> ❯ </span>`);
  jQuery('.slider-mobile-gutter').eq(0).prepend(`<span class="sliderPrev"> ❮ </span>`);
  if(window.innerWidth < 767){
    jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
  }
  document.addEventListener('click',function (e) {
    if (e.target.className == 'sliderNext') {
        changeSlide('next');
      // if(window.innerWidth < 767){
      //   jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
      // }
    } else if (e.target.className == 'sliderPrev') {
        changeSlide('prev');
      // if(window.innerWidth < 767){
      //   jQuery('.product__media-list').css('height',`${jQuery('.product__media-item.grid__item.slider__slide.is-active').height() + 54}`)
      // }
    }
  })

  

  document.addEventListener('click', function (e) {
    if(e.target.className.includes('openCareGuide')){
        document.querySelector('.careGuide').style.display = 'flex';
    } else if(e.target.className.includes('close')){
        document.querySelector('.careGuide').style.display = 'none';
    }
  })
  
})  

  if (document.querySelector('.product__info-container select[name="Unisex Size"]') != null ){
    document.querySelector('.product__info-container select[name="Unisex Size"]').addEventListener('change',function () {
        let selectedVal = document.querySelector('.product__info-container select[name="Unisex Size"] option:checked').value;
        let selectedId = document.querySelector(`input[name="Unisex Size"][value="${selectedVal}"]`).getAttribute('id');
        document.querySelector(`label[for="${selectedId}"]`).click();
        if(selectedVal.length != 0){
          document.querySelector('.product__info-container select[name="Unisex Size"]').classList.add('active')
        }
    })
  }
  
  if (document.querySelector('.product__info-container select[name="Size"]') != null ){
    document.querySelector('.product__info-container select[name="Size"]').addEventListener('change',function () {
        let selectedVal = document.querySelector('.product__info-container select[name="Size"] option:checked').value;
        let selectedId = document.querySelector(`input[name="Size"][value="${selectedVal}"]`).getAttribute('id');
        document.querySelector(`label[for="${selectedId}"]`).click();
        if(selectedVal.length != 0){
          document.querySelector('.product__info-container select[name="Size"]').classList.add('active')
        }
    })

  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productContact"]) return;
  try {
    
  document.querySelector('.contactClose').addEventListener('click', function () {
    document.querySelector('.contactWrapper').style.display = 'none';
})
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productFaq"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    if (e.target.classList[0] == 'faqQ') {
        if (e.target.className.includes('active')) {
            e.target.classList.remove('active');
            e.target.children[0].innerText = '+';
        }else{
            e.target.classList.add('active');
            e.target.children[0].innerText = '-';
        }
    }
})

  } catch(e) { console.error(e); }
})();
})();
